import { useEffect, useState, useRef } from "react";
import Card from "../../assets/images/card.png";
import Cash from "../../assets/images/cash.png";
import {
  clearOrder,
  getTotals,
  createOrder,
  getShowtimes,
  getItems,
  setOrderError,
  completeBooking,
  resetIds,
  setPrintLastOrder,
  completeCreatedOrder,
  setHasPrinted,
  fetchTax,
  manualUpdateItems,
  manualUpdateShowtimes,
  completeCreatedReservation,
} from "../../redux/slices";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import PaymentChannels from "./paymentChannelsModal";
import CashChangeModal from "./cashChangeModal";
import LoyaltyDetailsModal from "./LoyaltyDetailsModal";
import uuid from "react-uuid";
import ReceiptContainer from "./Receipt";
import { STATUS } from "../../utils/constants";
import addHours from "date-fns/addHours";
import { numToCurrency } from "../../utils/currencyHelper";
import { setLoyaltyData } from "../../redux/slices";
import { isToday } from "date-fns";
import { useTranslation } from "react-i18next";
import { downloadMcf } from "../../utils/mcfHelper";
import CardPaymentModal from "./CardPaymentModal";

const OrderPayment = () => {
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.orders);
  const { orderTotalAmount } = orders;
  const { userData, offlineMode, cinemaSettings } = useSelector(
    (state) => state.profile
  );
  const { itemsList } = useSelector((state) => state.items);
  const { showtimesList } = useSelector((state) => state.showtimes);
  const [paymentMode, setPaymentMode] = useState([]);
  const componentRef = useRef();
  // Guards against duplicate order submissions. The order-creation flow is
  // driven by state changes (paymentMode/discountCodeId/promoCodeId) rather than
  // a single click handler, so a fast double-tap or an extra state update could
  // otherwise fire createOrder twice for the same cart. We flip this to `true`
  // the instant a submission starts and only release it once the order has been
  // fully finalized (printed, print-failed, or rejected). A ref is used instead
  // of state so the guard updates synchronously and never lags behind a render.
  const isSubmittingRef = useRef(false);
  const [isCash, setIsCash] = useState(false);
  const [showChannelsModal, setShowChannelsModal] = useState(false);
  const [offlineSaleId, setOfflineSaleId] = useState("");
  const [promoCodeId, setPromoCodeId] = useState(null);
  const [discountCodeId, setDiscountCodeId] = useState(null);
  const [eventBookingId, setEventBookingId] = useState(null);
  const [eventBookingFilmName, setEventBookingFilmName] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [lumiData, setLumiData] = useState({
    phoneNumber: null,
    email: null,
    firstName: null,
    lastName: null,
    giftcardCode: null,
    giftcardCodeValue: 0,
  });
  const [openLoyaltyModal, setOpenLoyaltyModal] = useState(false);
  const [openCardModal, setOpenCardModal] = useState(false);
  const [loyaltyValue, setLoyaltyValue] = useState({ amount: 0, memberId: "" });
  const [pendingPaymentMethod, setPendingPaymentMethod] = useState(null);
  const { i18n, t } = useTranslation(["OrderPayment"]);
  const batchedOrderCreation = cinemaSettings?.orderCreation === 1;

  const [methodsList, setMethodsList] = useState([]);
  const [cashAmount, setCashAmount] = useState("");

  const isSilverbird = userData?.circuitId === "circuit-2e9293e2";
  const resetIsDisabled = () => {
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
  };

  // check if order is an online booking
  const isOnlineBooking =
    orders?.orderItems?.filter((item) => {
      return item?.bookedOrder === true;
    })?.length > 0;

  const storeLastOrder = () => {
    localStorage.setItem("lastOrder", JSON.stringify(orders.orderItems));
  };

  //function to set order id of offline sale before printing
  const setOrderIdBeforePrint = (func) => {
    if (offlineMode || batchedOrderCreation) {
      func && func();
    }
  };

  //function to reduce array for manualUpdate

  const arrayReducer = (array) => {
    return array.reduce((accumulator, currentValue) => {
      // Check if the fruit already exists in the accumulator
      if (accumulator[currentValue.id]) {
        // If it exists, add the quantity to the existing value
        accumulator[currentValue.id].quantity += currentValue.quantity;
      } else {
        // If it doesn't exist, initialize it with the current value
        accumulator[currentValue.id] = {
          id: currentValue.id,
          quantity: currentValue.quantity,
        };
      }
      return accumulator;
    }, {});
  };

  //function to manually update tickets and concessions for batched upload

  const manualUpdate = () => {
    const orderConcessions = orders?.orderItems
      ?.filter((item) => {
        return !item.showtimeId && !item.isPackage;
      })
      ?.map((x) => {
        return { id: x.id, quantity: x.orderQuantity };
      });
    const orderTickets = orders?.orderItems
      ?.filter((item) => {
        return item.showtimeId;
      })
      ?.map((x) => {
        return { id: x.showtimeId, quantity: x.orderQuantity };
      });

    // Create an object to store the accumulated quantities for each fruit
    const formattedConcession = Object.values(arrayReducer(orderConcessions));
    const formattedTickets = Object.values(arrayReducer(orderTickets));

    //Section for tickets
    if (orderTickets?.length > 0) {
      let updatedShowtimes = [];

      showtimesList?.result?.forEach((element) => {
        if (
          formattedTickets
            .map((x) => {
              return x.id;
            })
            .includes(element.id)
        ) {
          updatedShowtimes.push({
            ...element,
            seatsSold:
              element?.seatsSold +
              formattedTickets?.find((x) => x.id === element.id)?.quantity,
          });
        } else {
          updatedShowtimes.push(element);
        }
      });

      dispatch(
        manualUpdateShowtimes({ ...showtimesList, result: updatedShowtimes })
      );
    }

    //section for concession

    if (orderConcessions?.length > 0) {
      let updatedItems = [];

      itemsList?.forEach((element) => {
        //check for Single Items
        if (element?.itemGroup === "Single") {
          if (
            formattedConcession
              .map((x) => {
                return x.id;
              })
              .includes(element.id)
          ) {
            updatedItems.push({
              ...element,
              stock:
                element?.stock -
                formattedConcession?.find((x) => x.id === element.id)?.quantity,
            });
          } else {
            updatedItems.push(element);
          }
        } else {
          updatedItems.push(element);
        }
      });

      dispatch(manualUpdateItems(updatedItems));
    }
  };

  const onlineRefresh = () => {
    if (offlineMode || batchedOrderCreation) {
      manualUpdate();
    } else {
      dispatch(getShowtimes());
      dispatch(getItems());
    }
  };

  // Single source of truth for returning the terminal to a clean slate after a
  // sale. This used to live inline inside `onAfterPrint` only, which meant that
  // if the browser print dialog was dismissed — or never fired its after-print
  // event at all (popup blocked, printer error) — the order would already exist
  // on the server while the UI stayed stuck on the processing spinner, tempting
  // the operator into re-charging the customer. It is now a named function
  // invoked from every terminal outcome (successful print AND print error) so
  // the UI always recovers and the submission lock is always released.
  const finalizeOrder = () => {
    //to allow loading spinner keep spinner after network request has resolved but Receipt has not printed
    dispatch(setHasPrinted("hasPrinted"));
    storeLastOrder();
    setPaymentMode("");
    dispatch(clearOrder());
    onlineRefresh();
    dispatch(resetIds());
    setOfflineSaleId("");
    dispatch(setPrintLastOrder(false));
    setPromoCodeId(null);
    setDiscountCodeId(null);
    setEventBookingId(null);
    setEventBookingFilmName(null);
    dispatch(setLoyaltyData(null));
    setLoyaltyValue({ amount: 0, memberId: "" });
    setCashAmount("");
    setLumiData({
      phoneNumber: null,
      email: null,
      firstName: null,
      lastName: null,
      giftcardCode: null,
      giftcardCodeValue: 0,
    });
    setMethodsList([]);
    // Release the submission lock so the next sale can begin.
    isSubmittingRef.current = false;
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforePrint: () => {
      setOrderIdBeforePrint();
    },
    // Fires after the print dialog closes — whether the user printed or cancelled.
    onAfterPrint: finalizeOrder,
    // Fallback for when the print never reaches the dialog (e.g. popup blocked
    // or a content/render error). Without this `onAfterPrint` would never run,
    // leaving the spinner spinning on an order that already exists server-side.
    // We still reset the UI so the operator isn't blocked, and surface a clear
    // message telling them to reprint rather than charge the customer again.
    onPrintError: () => {
      dispatch(
        setOrderError({
          error: t("paymentchannel_modal.errors.print_failed"),
        })
      );
      finalizeOrder();
    },
  });

  useEffect(() => {
    dispatch(getTotals());
  }, [orders, dispatch]);

  const orderCreationHandler = () => {
    const isLoyaltySignUp = orders.orderItems?.some(
      (item) => item.isLoyaltyPlan
    );
    let firstTicketDate = new Date(
      orders?.orderItems?.filter((item) => {
        return item?.showtimeId;
      })[0]?.startTime
    );

    let itemSales = orders.orderItems
      .filter((item) => {
        return !item.showtimeId && !item.isPackage;
      })
      .map((item) => {
        return {
          cinemaId: userData.cinemaId,
          name: item.name,
          itemId: item.id,
          quantity: item.orderQuantity,
          itemParentId: item.parentId || null,
          itemPackageId: item.packageId || null,
          packageTicketId: item.packageTicketId || null,
          price: item.priceInPackage || item.price,
          isLoyaltyItem: item?.isDiscountApplied,
          amount: !item.priceInPackage
            ? +item.orderQuantity * +item.price
            : +item.orderQuantity * +item.priceInPackage,
        };
      });

    let ticketSales = orders.orderItems
      .filter((item) => {
        return item.showtimeId;
      })
      .map((item) => {
        return {
          cinemaId: userData.cinemaId,
          showtimeId: item.showtimeId,
          ticketId: item.ticketId,
          voucherCode: item.voucherCode || null,
          priceCardTicketId: item.priceCardTicketId,
          quantity: item.orderQuantity,
          ticketPrice: item.priceInPackage || item.price,

          packageTicketId: item.packageTicketId || null,
          amount: !item.priceInPackage
            ? +item.orderQuantity * +item.price
            : +item.orderQuantity * +item.priceInPackage,
          seatNumber: item?.seatNumber,
          seatLayoutId: item?.seatLayoutId,
          rowName: item?.rowName,
          isLoyaltyTicket: item?.isDiscountApplied,
        };
      });

    const isBookedOrder = orders.orderItems.filter((item) => {
      return item.bookedOrder === true;
    });
    const isReservedOrder = orders.orderItems.filter((item) => {
      return item.bookedOrder === false && item.reservedOrder === true;
    });

    if (orders.printLastOrder) {
      return () => {
        console.log("order reprint");
      };
    }
    //this if block gets triggered if the order is an offline order
    if (offlineMode || batchedOrderCreation) {
      //setting the random id variable to the generated uuid
      const randomId = uuid();

      setOfflineSaleId(randomId.slice(0, 16));

      let offlineSales =
        JSON.parse(localStorage.getItem("offlineOrders")) || [];
      const newOfflineSales = [
        ...offlineSales,
        {
          cinemaId: userData.cinemaId,
          itemSales,
          ticketSales,
          sourceId: "source-d9c05d",
          paymentChannels: paymentMode,
          // Datetimereserved here was modified to cater for advance ticket sales.
          // In a case where is a ticket sale it picks the datetime reserved based on the showtime
          // of the ticket
          dateTimeReserved:
            ticketSales.length > 0
              ? isToday(firstTicketDate)
                ? new Date()
                : firstTicketDate
              : new Date(),
          offlineId: randomId,
          discountCodeId: null,
          promoCodeId: null,
          eventBookingId,
          userId: userData.id,
          loyalty: orders?.loyaltyData,
        },
      ];
      localStorage.setItem("offlineOrders", JSON.stringify(newOfflineSales));
      localStorage.setItem("lastOrderId", JSON.stringify(randomId));

      return;
    }
    if (isBookedOrder.length > 0) {
      return dispatch(completeBooking(orders.bookingDetails.id));
    } else if (isReservedOrder.length > 0) {
      return dispatch(
        completeCreatedReservation({
          bookingId: orders.bookingDetails.id,
          orders: paymentMode.map((mode) => ({
            channelId: mode.channelId || null,
            otherChannelId: mode.otherChannelId || null,
            amount: mode.amount,
          })),
        })
      );
    } else {
      return dispatch(
        createOrder({
          cinemaId: userData.cinemaId,
          itemSales: isLoyaltySignUp ? [] : itemSales,
          ticketSales: isLoyaltySignUp ? [] : ticketSales,
          sourceId: "source-d9c05d",
          paymentChannels: paymentMode,
          // Datetimereserved here was modified to cater for advance ticket sales.
          // In a case where is a ticket sale it picks the datetime reserved based on the showtime
          // of the ticket
          dateTimeReserved:
            ticketSales.length > 0
              ? isToday(firstTicketDate)
                ? new Date()
                : firstTicketDate
              : new Date(),
          offlineId: null,
          discountCodeId,
          promoCodeId,
          eventBookingId,
          filmName: eventBookingFilmName,
          loyalty: orders.loyaltyData,
          lumiLoyalty: lumiData,
          memberShipPlanId: orders?.loyaltyData?.plan?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (orders.printLastOrder && !offlineMode) {
      handlePrint();
      return;
    }

    if (offlineMode && isOnlineBooking) {
      dispatch(
        setOrderError({
          error: t("paymentchannel_modal.errors.order_mode"),
        })
      );
      return;
    }

    if ((offlineMode || batchedOrderCreation) && paymentMode.length > 0) {
      // Block re-entry while a sale is already being processed/printed.
      if (isSubmittingRef.current) return;
      isSubmittingRef.current = true;
      orderCreationHandler();
      return;
    }

    //check to ensure that users cannot add a new item when trying to complete a booked order
    if (
      isOnlineBooking &&
      orders?.orderItems?.find((item) => {
        return item?.bookedOrder !== true;
      })
    ) {
      dispatch(
        setOrderError({
          error: t("paymentchannel_modal.errors.order2"),
        })
      );

      return;
    }

    if (paymentMode.length > 0 && !offlineMode && !batchedOrderCreation) {
      // Block re-entry while a sale is already being processed/printed.
      if (isSubmittingRef.current) return;
      isSubmittingRef.current = true;
      dispatch(setHasPrinted("isProcessing"));
      orderCreationHandler()
        .unwrap()
        .then((data) => {
          dispatch(completeCreatedOrder(data))
            .unwrap()
            .then(() => {
              dispatch(
                fetchTax({
                  cinemaId: userData.cinemaId,
                  orderId: data,
                  amount: orders?.orderTotalAmount,
                })
              )
                .unwrap()
                .then((taxData) => {
                  // if (cinemaSettings?.generateJson) {
                  //   downloadJsonFile(taxData);
                  // }
                  handlePrint();
                });
            });
        })
        .catch((err) => {
          // Release the lock so the operator can retry after a failure.
          isSubmittingRef.current = false;
          dispatch(setHasPrinted("failed"));
          dispatch(
            setOrderError({
              error: err || t("paymentchannel_modal.errors.create_order"),
            })
          );
        });
    }

    //for orders that just have a discount code, promocode or event booking
    if (
      paymentMode.length === 0 &&
      !offlineMode &&
      (discountCodeId || promoCodeId || eventBookingId)
    ) {
      // Block re-entry while a sale is already being processed/printed.
      if (isSubmittingRef.current) return;
      isSubmittingRef.current = true;
      orderCreationHandler()
        .unwrap()
        .then((data) => {
          dispatch(completeCreatedOrder(data))
            .unwrap()
            .then(() => {
              dispatch(
                fetchTax({
                  cinemaId: userData.cinemaId,
                  orderId: data,
                  amount: orders?.orderTotalAmount,
                })
              )
                .unwrap()
                .then((taxData) => {
                  if (cinemaSettings?.generateJson) {
                    // downloadJsonFile(taxData);
                    downloadMcf({
                      taxData,
                      order: orders,
                      userData,
                      paymentMode,
                      cashAmount,
                    });
                  }
                  handlePrint();
                });
            });
        })
        .catch((err) => {
          // Release the lock so the operator can retry after a failure.
          isSubmittingRef.current = false;
          dispatch(
            setOrderError({
              error: err || t("paymentchannel_modal.errors.create_order"),
            })
          );
        });
    }
  }, [paymentMode, dispatch, discountCodeId, promoCodeId, eventBookingId]);

  useEffect(() => {
    if (
      offlineSaleId &&
      paymentMode.length &&
      (offlineMode || batchedOrderCreation)
    ) {
      dispatch(
        fetchTax({
          cinemaId: userData.cinemaId,
          orderId: offlineSaleId,
          amount: orders?.orderTotalAmount,
        })
      )
        .unwrap()
        .then((data) => {
          if (cinemaSettings?.generateJson) {
            // downloadJsonFile(data);
            downloadMcf({
              taxData: data,
              order: orders,
              userData,
              paymentMode,
              cashAmount,
            });
          }
        });
      handlePrint();
    }
  }, [
    offlineSaleId,
    offlineMode,
    paymentMode.length,
    discountCodeId,
    promoCodeId,
    eventBookingId,
    batchedOrderCreation,
  ]);

  const executeCardPayment = () => {
    if (
      orders.orderItems?.length > 0 &&
      orders.createOrderStatus !== STATUS.PENDING
    ) {
      // Last line of defence before money goes on the wire: the modal already
      // caps this, but an uncapped value here posts a negative card channel.
      const loyaltyAmount = Math.min(
        loyaltyValue?.amount || 0,
        orders.orderTotalAmount
      );
      const cardAmount = orders.orderTotalAmount - loyaltyAmount;
      const channels = [];
      const methods = [];

      if (loyaltyAmount > 0) {
        channels.push({
          channelId: "channel-26998e",
          ...loyaltyValue,
          amount: +loyaltyAmount,
        });
        methods.push(
          ` ${t("paymentchannel_modal.label.loyalty")}:${numToCurrency(
            loyaltyAmount
          )}`
        );
      }

      channels.push({
        channelId: "channel-c2e01f",
        amount: cardAmount,
      });
      methods.push(
        ` ${t("paymentchannel_modal.label.card")}:${numToCurrency(cardAmount)}`
      );

      setPaymentMode(channels);
      setMethodsList(methods);
      setOpenCardModal(false);
    }
  };

  const processCardPayment = () => {
    if (offlineMode || batchedOrderCreation) {
      setIsDisabled(true);
      resetIsDisabled();
      clearTimeout(resetIsDisabled);
    }
    if (cinemaSettings?.enforceLoyalty && !isOnlineBooking && !offlineMode) {
      setOpenCardModal(true);
    } else {
      executeCardPayment();
    }
  };

  const processCashPayment = () => {
    if (orders.orderItems?.length > 0) {
      if (!isSilverbird) {
        setIsCash(true);
      } else {
        if (offlineMode || cinemaSettings?.orderCreation === 1) {
          setIsDisabled(true);
          resetIsDisabled();
          clearTimeout(resetIsDisabled);
        }
        if (orders.createOrderStatus !== STATUS.PENDING) {
          const loyaltyAmount = Math.min(
            loyaltyValue?.amount || 0,
            orders.orderTotalAmount
          );
          const cashAmount = orders.orderTotalAmount - loyaltyAmount;
          const channels = [];
          const methods = [];

          if (loyaltyAmount > 0) {
            channels.push({
              channelId: "channel-26998e",
              ...loyaltyValue,
              amount: +loyaltyAmount,
            });
            methods.push(
              ` ${t("paymentchannel_modal.label.loyalty")}:${numToCurrency(
                loyaltyAmount
              )}`
            );
          }

          channels.push({
            channelId: "channel-55402e",
            amount: cashAmount,
          });
          methods.push(
            `${t("cashChange_modal.label.cash")}:${numToCurrency(cashAmount)}`
          );

          setPaymentMode(channels);
          setMethodsList(methods);
        }
      }
    }
  };

  const handleCardClick = () => {
    if (orders.orderItems?.length > 0) {
      if (
        cinemaSettings?.enforceLoyalty &&
        orders.createOrderStatus !== STATUS.PENDING &&
        !isOnlineBooking &&
        !offlineMode
      ) {
        setPendingPaymentMethod("card");
        setLoyaltyValue({ amount: 0, memberId: "" });
        setOpenLoyaltyModal(true);
      } else {
        processCardPayment();
      }
    }
  };

  const handleCashClick = () => {
    if (
      cinemaSettings?.enforceLoyalty &&
      orders.orderItems?.length > 0 &&
      orders.createOrderStatus !== STATUS.PENDING &&
      !isOnlineBooking &&
      !offlineMode
    ) {
      setPendingPaymentMethod("cash");
      setLoyaltyValue({ amount: 0, memberId: "" });
      setOpenLoyaltyModal(true);
    } else {
      processCashPayment();
    }
  };

  const handleLoyaltyClose = (isSuccess) => {
    setOpenLoyaltyModal(false);
    if (isSuccess === true) {
      if (pendingPaymentMethod === "card") {
        processCardPayment();
      } else if (pendingPaymentMethod === "cash") {
        processCashPayment();
      }
    } else if (pendingPaymentMethod) {
      // Backing out of an enforced loyalty prompt cancels the payment. Say so —
      // otherwise the operator taps Cash and nothing visibly happens.
      dispatch(
        setOrderError({
          error: t("paymentchannel_modal.errors.loyalty_required"),
        })
      );
    }
    setPendingPaymentMethod(null);
  };

  // Clamped once for the JSX below, so a stale over-total redemption can never
  // render (or post) a negative payable amount.
  const appliedLoyaltyAmount = Math.min(
    loyaltyValue?.amount || 0,
    orders.orderTotalAmount || 0
  );

  const isDisabledCondition =
    offlineMode || cinemaSettings?.orderCreation === 1 ? isDisabled : false;
  return (
    <>
      <div className=" h-[15%]  rounded shadow-md border-2 flex py-1">
        <button
          className=" w-[33%] h-[100%]"
          onClick={handleCardClick}
          disabled={offlineMode || batchedOrderCreation ? isDisabled : false}
        >
          <div className="flex justify-center mb-2">
            <img src={Card} alt="cardimg" />
          </div>

          <p className="text-center text-primary font-bold">
            {t("payment.card")}
          </p>
        </button>
        <button
          className=" w-[34%] h-[100%] border-x-2 border-primary "
          disabled={isSilverbird ? isDisabledCondition : false}
          onClick={handleCashClick}
        >
          <div className="flex justify-center mb-2">
            <img src={Cash} alt="cashimg" />
          </div>
          <p className="text-center text-primary font-bold">
            {t("payment.cash")}
          </p>
        </button>

        <div className="hidden">
          <ReceiptContainer
            ref={componentRef}
            offlineSaleId={offlineSaleId}
            methodsList={methodsList}
          />
        </div>
        <div
          className="h-[100%] w-[33%]"
          onClick={() => {
            if (orders.orderItems?.length > 0) {
              setShowChannelsModal(true);
            }
          }}
        >
          <div
            className=" w-[100%] h-[65%]  bg-no-repeat bg-contain bg-center"
            style={{
              backgroundImage: `url(${process.env.REACT_APP_LOGO_URL2})`,
            }}
          ></div>
          <p className="text-center text-primary font-bold text-[12px]">
            {t("payment.multi")}
          </p>
        </div>
      </div>
      {orders.orderItems?.length > 0 && (
        <PaymentChannels
          openStatus={showChannelsModal}
          closeFunc={() => {
            setShowChannelsModal(false);
          }}
          setPaymentMode={(channels) => {
            setPaymentMode(channels);
          }}
          setDiscountCodeId={setDiscountCodeId}
          setPromoCodeId={setPromoCodeId}
          setEventBookingId={setEventBookingId}
          setEventBookingFilmName={setEventBookingFilmName}
          setLumiData={setLumiData}
          lumiData={lumiData}
          setMethodsList={setMethodsList}
        />
      )}
      {orders.orderItems?.length > 0 && (
        <CashChangeModal
          openStatus={isCash}
          closeFunc={() => {
            setIsCash(false);
          }}
          setPaymentMode={(channels) => {
            if (appliedLoyaltyAmount > 0) {
              const newChannels = [...channels];
              newChannels.push({
                channelId: "channel-26998e",
                ...loyaltyValue,
                amount: +appliedLoyaltyAmount,
              });
              setPaymentMode(newChannels);
            } else {
              setPaymentMode(channels);
            }
          }}
          setMethodsList={(methods) => {
            if (appliedLoyaltyAmount > 0) {
              const newMethods = [...methods];
              newMethods.push(
                ` ${t("paymentchannel_modal.label.loyalty")}:${numToCurrency(
                  appliedLoyaltyAmount
                )}`
              );
              setMethodsList(newMethods);
            } else {
              setMethodsList(methods);
            }
          }}
          cashAmount={cashAmount}
          setCashAmount={setCashAmount}
          payableAmount={orders.orderTotalAmount - appliedLoyaltyAmount}
        />
      )}
      <LoyaltyDetailsModal
        openStatus={openLoyaltyModal}
        closeFunc={handleLoyaltyClose}
        setLoyaltyValue={setLoyaltyValue}
      />
      <CardPaymentModal
        openStatus={openCardModal}
        closeFunc={() => setOpenCardModal(false)}
        payableAmount={orders.orderTotalAmount - appliedLoyaltyAmount}
        onConfirm={executeCardPayment}
      />
    </>
  );
};
export default OrderPayment;
